import "emoji-picker-element";
import { useEffect, useRef } from "react";
import styled from "styled-components";

const EmojiPickerWrapper = ({ onEmojiSelect, onClose, top = null, left= null, right=null }) => {
  const wrapperRef = useRef();

  const EmojiWrapper = styled.div`
    position: absolute;
    ${top ? `top: ${top}px;` : "top: -400px;"}
    ${left ? `left: ${left}px;` : "left: unset;"}
     ${right ? `right: ${right}px !important;` : "right: 0;"}
    z-index: 100;

    @media (max-width: 768px) {
      position: fixed;
      top: unset;
      bottom: 500px;
      right: 5%;
      left: 5%;
    }
  `;

  useEffect(() => {
    const picker = wrapperRef.current?.querySelector("emoji-picker");

    const handleEmojiClick = (e) => {
      if (onEmojiSelect) {
        onEmojiSelect(e.detail.unicode);
      }
    };

    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        if (onClose) onClose();
      }
    };

    if (picker) {
      picker.addEventListener("emoji-click", handleEmojiClick);
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      if (picker) {
        picker.removeEventListener("emoji-click", handleEmojiClick);
      }
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onEmojiSelect, onClose]);

  return (
    <EmojiWrapper ref={wrapperRef}>
      <emoji-picker></emoji-picker>
    </EmojiWrapper>
  );
};



export default EmojiPickerWrapper;
